import React, { useEffect } from 'react';
import Table, { renderEllipsis, TableProps } from 'components/table';
import { useAppDispatch, useTypedSelector } from 'store/index';
import { fetchApplicationAccounts } from 'store/application';
import { Account } from 'store/user';

const detailHeaders: TableProps['headers'] = [
  {
    label: '账户ID',
    name: 'account_id',
    width: 216,
    tooltip: '您所属的服务商ID或直客ID；其中服务商ID开通后，所有关联的子客广告主ID将获得该应用的使用权限',
  },
  {
    label: '账户名称',
    name: 'account_name',
    width: 216,
  },
  {
    label: '开通状态',
    name: 'status_text',
    width: 104,
    filterable: true,
    filterSource: [
      { label: '已开通', value: '已开通' },
      { label: '未开通', value: '未开通' },
    ],
  },
  {
    label: '开户人',
    name: 'contact_info',
    width: 216,
    tooltip: '可操作开通应用的QQ/微信号：服务商ID的超级管理员/直客ID的开户号',
    render: renderEllipsis(
      200,
      ({ qq, wechat, spid }: Account) =>
        `${qq ? `QQ:${qq} ` : ''}${wechat ? `微信:${wechat} ` : ''}${spid ? `SPID:${spid}` : ''}`
    ),
  },
];

const DetailDialog: React.FC<{ id: string }> = ({ id }) => {
  const dispatch = useAppDispatch();
  const {
    application: { appAccountsMap, appAccountsLoading },
  } = useTypedSelector((state) => state);

  useEffect(() => {
    dispatch(fetchApplicationAccounts(id));
  }, [dispatch, id]);

  return (
    <>
      <div className="tips">
        <span>Tips</span>
        <span>
          账户ID未开通时，请联系下方表格中账户ID对应的开户人登录
          <a href="https://isv.e.qq.com/application-list" target="_blank" rel="noreferrer">
            https://isv.e.qq.com/application-list
          </a>
          ，点击“一键授权”进行开通
        </span>
      </div>
      <Table
        headers={detailHeaders}
        searchableCols={['account_id', 'account_name']}
        data={appAccountsMap[id]}
        loading={appAccountsLoading}
      />
    </>
  );
};

export default DetailDialog;
